<template>
  <div class="col-12 backgroundForm">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Ejecucion Presupuestaria</h4>
            <p>Ejecucion del Presupuesto programado para las diferentes dependencias</p>        
        </div>

        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="exec-reg" data-toggle="tab" href="#exec-gral-dep" role="tab" aria-controls="nav-gral" aria-selected="true"><font-awesome-icon icon="plus" /> 1. Registro</a>

                <a class="nav-item nav-link" id="exec-approv-gral" data-toggle="tab" href="#exec-approv-dep" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="tasks" /> 2. Aprobar/Negar </a>

                <a class="nav-item nav-link" id="exec-notify" data-toggle="tab" href="#not-approv-dep" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="paper-plane" /> 3. Notificar/Descargar</a>
            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <!-- Registro de la solicitud de ejecucion presupuestaria -->
            <div class="tab-pane fade show active" id="exec-gral-dep" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Registro Solicitud Gasto {{ dependencie_exec_ceiling.name_port }}
                    </div>
                </div>
                <button class="btn btn-danger col-12 col-md-1 offset-md-10" @click="mResetForm"><font-awesome-icon icon="sync-alt" /> Limpiar</button>
                <div class="form-row">
                    <div class="form-group col-12 col-md-4">
                        <label for="t_file">Tipo Documento</label>
                        <select id="t_document" :disabled="is_disabled" v-model="file_select" class="form-control">
                            <option v-for="tf in type_files" :key="tf.id" :value="tf">{{ tf.detail }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="t_file">Fecha Solicitud</label>
                        <input type="date" name="date_r" id="date_r" class="form-control" :disabled="is_disabled" v-model="date_req_exec">
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="t_file">Fuente</label>
                        <select id="t_document" :disabled="is_disabled" v-model="font_select" class="form-control">
                            <option v-for="fegr in font_egress" :key="fegr.id" :value="fegr">{{ fegr.detail }}</option>
                        </select>
                    </div>            
                </div>

                <div class="form-row">
                    <div class="form-group col-12 col-md-4">
                        <label for="year_exec">Dependencia</label>
                        <select id="portCeiling" v-model="dependencie_exec_ceiling" class="form-control" :disabled="is_disabled">
                            <option v-for="d in dependencies" :key="d.id" :value="d">{{ d.name_port }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="year_exec">Seleccione Mes(es)</label>
                        
                        <multiselect v-model="month_select" :options="months" :multiple="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Seleccione el Mes" label="title" track-by="id" :selectLabel="options_select.selectLabel" :selectedLabel="options_select.selectedLabel" :deselectLabel="options_select.deselectLabel" :disabled="is_disabled">
                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} mes(es) seleccionado(s)</span></template>
                        </multiselect>                        
                    </div>
                    <transition name="fade" mode="out-in">
                    <div class="form-group col-12 col-md-4" v-if="month_select.length > 0">
                        <label for="month-select">Mes(es) Seleccionado(s)</label>
                        <div>
                            <h5><span class="badge badge-success" v-for="m in month_select" :key="m.id"> {{ m.title }} </span></h5>
                        </div>
                    </div>
                    </transition>
                </div>

                <div class="form-row">
                    <div class="col-12 col-sm-2">
                        <label for="new_code_budget">Gestion</label>
                        <select class="form-control" name="year_execute" v-model="year_execute" :disabled="is_disabled">
                            <option v-for="y in year_option_execute" :key="y.id" :value="y.id">{{ y.anio }}</option>
                        </select>
                    </div>
                    <transition name="fade" mode="out-in">
                    <div class="form-group col-12 col-md-4">
                        <label for="year_exec">Partida</label>
                        <select id="budgetPort" v-model="budget_ceiling_select" class="form-control">
                            <option v-for="br in budget_ceiling_dependencie" :key="br.id" :value="br">{{ br.budget_code }} - {{ br.glosa }}</option>
                        </select>
                    </div>
                    <!-- <div class="form-group col-12 col-md-4" v-else>
                        <label for=not_select>Partida</label>
                        <input type="text" readonly name="not_select" class="form-control-plaintext" value="Sin Registros">
                    </div> -->
                    </transition>
                    <div class="form-group col-12 col-md-2">
                        <label for="year_exec">Imp. Solicitado</label>
                        <input type="number" name="year_exec" class="form-control" v-model="import_req" placeholder="0">
                    </div>
                    <div class="form-group col-12 col-md-2">
                        <label for="year_exec">Imp. Aprobado</label>
                        <input type="number" name="year_exec" class="form-control" v-model="import_approv" placeholder="0">
                    </div>
                    <div class="form-group col-12 col-md-2">
                        <label for="year_exec">Diferencia</label>
                        <input type="number" disabled name="year_exec" class="form-control-plaintext" v-model="cDiffReqApprov">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-12">
                        <label for="d_d">Descripcion del Documento</label>
                        <!-- <textarea name="d_d" id="d_d" cols="10" rows="2" class="form-control" v-model="desc_file" placeholder="Ejm. Documento solicitado en fecha 00/00/0000" autocomplete="on"></textarea> -->
                        <input type="text" name="d_d" id="d_d" class="form-control" v-model="desc_file" placeholder="Ejm. Documento solicitado en fecha 00/00/0000" />

                    </div>
                </div>
                <button class="btn btn-success col-12 col-md-2 offset-md-4" @click="mAddExec"><font-awesome-icon icon="folder-plus" size="2x" /><br>Agregar</button>
                <transition name="fade-in" mode="out-in">
                <button v-if="dts_budget_exec.length > 0" class="btn btn-info col-12 col-md-2" @click="mSaveExecute"><font-awesome-icon icon="save" size="2x" /><br>Registrar</button>
                </transition>
                <br><br>
                <transition name="fade" mode="out-in">
                <div class="table-responsive" v-if="dts_budget_exec.length > 0">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Partida</th>
                                <th>Importe Requerido</th>
                                <th>Importe Aprobado</th>
                                <th>Diferencia</th>
                                <th>Eliminar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dr, index) in dts_budget_exec" :key="dr._id">
                                <td>{{ index+1 }}</td>
                                <td>{{ dr.budget_code }} - {{ dr.glosa }}</td>
                                <td>{{ dr.import_req }}</td>
                                <td>{{ dr.import_approv }}</td>
                                <td>{{ dr.import_dif }}</td>
                                <td><button class="btn btn-danger" @click="mDeleteItem(dr.budget_code)"><font-awesome-icon icon="window-close" /></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </transition>
            </div>

            <!-- Aprobacion o Negacion de la Solicitud de gasto -->
            <div class="tab-pane fade show" id="exec-approv-dep" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Aprobacion o Negacion de la Solicitud
                    </div>
                </div>
                <h6>CRITERIOS DE BUSQUEDA</h6>
                <hr>
                <div class="form-row">
                    <div class="input-group col-12 col-md-8 offset-md-2 mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Dependencia</span>
                        </div>
                        <select id="portCeiling" v-model="dependencie_approv_select" class="form-control">
                            <option v-for="d in dependencies" :key="d.id" :value="d">{{ d.name_port }}</option>
                        </select>
                        <div class="input-group-append">
                            <button class="btn btn-outline-danger" @click="mSearchPendingApprov">
                                <font-awesome-icon icon="search"/>
                            </button>            
                        </div>
                    </div>                    
                </div>

                <div class="table-responsive" v-if="dependencie_approv_request.length > 0">
                    <table class="table table-hover">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" width="5%">#</th>
                                <th scope="col" width="60%">Documento</th>
                                <th scope="col" width="35%">Preventivo - Aprobacion / Negacion</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ndp, index) in dependencie_approv_request" :key="ndp.id">
                                <th scope="row">{{ index+1 }}</th>
                                <td><b>{{ ndp.port }}</b><br><b>{{ ndp.type_document }} {{ndp.correlative}}/{{ndp.year_egress}}</b> FP: {{ ndp.date_present }} <br>Días Transcurridos: {{ ndp.days_current }}<br>Importe: {{ ndp.import_gral_approv }} Bs.<br>{{ ndp.glosa }}</td>
                                <td>
                                    <div class="input-group">
                                        <input type="text" class="form-control" placeholder="Preventivo" aria-label="Recipient's username" v-model="ndp.prevent" aria-describedby="basic-addon2">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-primary" type="button" @click="mApprovDocument(ndp)">Aprobado</button>
                                            <button class="btn btn-outline-danger" type="button" @click="mNegateDocument(ndp)">Negado</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <div class="alert alert-warning">Sin Registros</div>
                </div>

            </div>

            <!-- Notificacion de la Aprobacion de la Solicitud -->
            <div class="tab-pane fade show" id="not-approv-dep" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Registro y descripcion de los medios de Notificacion al Responsable o Capitania con relacion a la aprobacion de su solicitud de Ejecución Presupuestaria
                    </div>
                </div>
                <h6>CRITERIOS DE BUSQUEDA</h6>
                <hr>
                <div class="form-row">
                    <div class="input-group col-12 col-md-8 offset-md-2 mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Dependencia</span>
                        </div>
                        <select id="portCeiling" v-model="dependencie_notify_select" class="form-control">
                            <option v-for="d in dependencies" :key="d.id" :value="d">{{ d.name_port }}</option>
                        </select>
                        <div class="input-group-append">
                            <button class="btn btn-outline-danger" @click="mSearchPendingNotify">
                                <font-awesome-icon icon="search"/>
                            </button>            
                        </div>
                    </div>                    
                </div>

                <div class="table-responsive-lg" v-if="dependencie_notify_list.length > 0">
                    <table class="table table-hover">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" width="3%">#</th>
                                <th scope="col" width="32%">Documento</th>
                                <th scope="col" width="60%">Descripcion Notificacion</th>
                                <th scope="col" width="5%">Finalizar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ndp, index) in dependencie_notify_list" :key="ndp.id">
                                <th scope="row" width="3%">{{ index+1 }}</th>
                                <td width="32%"><b>{{ ndp.port }}</b><br><b>{{ ndp.type_document }} {{ndp.correlative}}/{{ndp.year_egress}}</b> <br> FA: {{ ndp.date_approve }} <br>DT: {{ ndp.days_current }} Días<br>Importe: {{ ndp.import_gral_approv }} Bs.</td>
                                <td width="60%">
                                    <transition name="fade-in" mode="out-in">
                                    <div class="my-scroll" :id="ndp.id" v-if="ndp.disabled">{{ ndp.notify }}</div>
                                    <textarea class="form-control" name="notify" :id="ndp.id" cols="30" rows="5" v-model="dependencie_notify_aux.notify" v-else></textarea>
                                    </transition>
                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-warning" type="button" @click="mEditNotify(index)" v-if="ndp.disabled"><font-awesome-icon icon="edit"  /></button>
                                            <div v-else>
                                                <button class="btn btn-outline-success" type="button" @click="mSaveNotify(index)"><font-awesome-icon icon="save" /></button>
                                                <button class="btn btn-outline-danger" type="button" @click="mCancelNotify(index)"><font-awesome-icon icon="times-circle" /></button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-danger" type="button" @click="mDocumentDischarge(ndp)"><font-awesome-icon icon="check" size="2x" /></button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <div class="alert alert-warning">Sin Registros</div>
                </div>
            </div>
        </div>

        <modal-loading :id-modal="id_m_progress" :title="title_m" :status-send="send_dispatch" ></modal-loading>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
const qs=require('qs');

import modalLoading from '../modal/modalLoading';
import modalView from '../modal/modalView';

export default {
    data(){
        return{
            dependencie_notify_aux:{},
            dependencie_notify_select:[],
            dependencie_notify_list:[],
            dependencie_approv_request:[],
            dependencie_approv_select:null,
            send_dispatch:true,
            id_m_progress:'modal_execute_loading',
            title_m:'Cargando',
            months:[
                {id:1, title:"Enero"},
                {id:2, title:"Febrero"},
                {id:3, title:"Marzo"},
                {id:4, title:"Abril"},
                {id:5, title:"Mayo"},
                {id:6, title:"Junio"},
                {id:7, title:"Julio"},
                {id:8, title:"Agosto"},
                {id:9, title:"Septiembre"},
                {id:10, title:"Octubre"},
                {id:11, title:"Noviembre"},
                {id:12, title:"Diciembre"}
            ],
            month_select:[],
            options_select:{
                selectLabel:'Seleccionar',
                selectedLabel:'Seleccionado',
                deselectLabel:'Deseleccionar'
            },
            dependencies:[],
            dependencie_exec_ceiling:{id:0, name_port:''},
            budget_ceiling_dependencie:[],
            budget_ceiling_select:[],
            year_exec_budget:0,
            is_disabled:false,
            type_files:[],
            font_egress:[{"id":11,"detail":"Fuente 11 Recursos Propios"}, {"id":10,"detail":"Fuente 10 Recursos Externos"}],
            dts_exec_master:{
                y:0,
                year_exec:0,
                dependencie:'',
                t_document:'',
                f_select:'',
                d_document:'',
                date_present:'',
                import_req_gral:0,
                import_approv_gral:0
            },
            dts_exec_month:[],
            dts_budget_exec:[],
            import_req:null,
            import_approv:null,
            file_select:[],
            font_select:[],
            desc_file:null,
            date_req_exec:null,
            year_option_execute:[],
            year_execute:0,
            year_vigent_budget:0
        }
    },
    mounted(){
        this.mCallDependencies();
        this.mGetToday();
        this.mCallBudgetRegisters();
        this.mObtainYear();
    },
    methods:{
        mObtainYear(){
            let anio=new Date();
            let initYear=anio.getFullYear()-3;
            let currentYear=anio.getFullYear();
            for(let i = initYear ; i<=currentYear ;i++){
                let auxYear={
                    id:i,
                    anio:i
                }
                this.year_option_execute.push(auxYear);
            }
        },
        async mDocumentDischarge(e){
            let message = {
                    title: 'Descargo Documento',
                    body: `¿Desea finalizar el Documento <b>${e.type_document} ${e.correlative} / ${e.year_egress}</b>, indicando que el <b>Descargo</b> ya fue entregado en oficinas de la Dirección ?`
            };
            let dts_discharge={
                id_exec:e.id_exec
            }
            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            });

            npr.then( async (msg) =>{
                if(msg){
                    try {
                        this.title_m="Finalizando";
                        this.activeModal(this.id_m_progress);
                            
                        let adp=await axios.post(`saveDischargeDocument?api_token=${Vue.auth.getToken()}`, qs.stringify(dts_discharge));
                            // console.log(adp);
                        if(adp.data.status){
                                // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                            toastr.success(adp.data.response, 'Exito');
                            this.mDeleteDocumentDischarge(e.id_exec);
                                // eliminar al documento de la lista
                                
                        }else{                            
                                // solo mostramos el mensaje de error
                            toastr.error(`${adp.data.response}`, 'Error');
                        }
                        setTimeout(()=>{
                            this.inactiveModal(this.id_m_progress);
                        }, 500)
                    } catch (error) {
                        toastr.error('Consulte al administrador', 'Error');
                        setTimeout(()=>{
                            this.inactiveModal(this.id_m_progress);
                        }, 500)
                    }
                }else{
                    console.log('se ha rechazado el registro de gasto');
                }
            })
        },
        mDeleteDocumentDischarge(quest){
            let idel;
            let auxBudget;
            this.dependencie_notify_list.forEach((v, key)=>{
                if(quest===v.id_exec){
                    idel=key;
                }
            });
            // posteriormente eliminar la copia en el auxiliar                        
            this.dependencie_notify_list.splice(idel, 1);
        },
        async mSaveNotify(index){
             if(this.dependencie_notify_aux.indice===index){
                this.dependencie_notify_list[index].notify=this.dependencie_notify_aux.notify;
                this.dependencie_notify_list[index].disabled=true;
                this.dependencie_notify_aux={};
                
                try {
                    let dts_notify={
                            id_exec:this.dependencie_notify_list[index].id_exec,
                            notify:this.dependencie_notify_list[index].notify
                        };
                    this.title_m="Actualizando";
                    this.activeModal(this.id_m_progress);
                    let sun=await axios.post(`updateNotification?api_token=${Vue.auth.getToken()}`,qs.stringify(dts_notify));
                    if(sun.data.status){
                        toastr.success(sun.data.response, 'Exito')
                    }else{
                        toastr.warning(sun.data.response, 'Error')
                    }
                    setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);                        
                    }, 500)
                } catch (error) {
                    
                    setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);
                        toastr.error('Error UDN-1', 'Error');
                    }, 500)
                }
                
            }else{
                toastr.warning(`Verifique la Notificacion editada en la fila ${index+1}`, 'Advertencia');
            }
        },
        mCancelNotify(index){
            this.dependencie_notify_list[index].disabled=true;
        },
        mEditNotify(index){
            this.mVerifyCampEdition();
            // console.log(this.dependencie_notify_list[index])
            this.dependencie_notify_aux={
                id_exec:this.dependencie_notify_list[index].id_exec,
                notify:this.dependencie_notify_list[index].notify,
                indice:index
            }
            this.dependencie_notify_list[index].disabled=false;
        },
        mVerifyCampEdition(){
            for(let key in this.dependencie_notify_list){
                if( !(this.dependencie_notify_list[key].disabled) ){
                     this.dependencie_notify_list[key].disabled=true;
                     this.dependencie_notify_aux={};
                }
            }
        },
        async mSearchPendingNotify(){
            
            this.dependencie_notify_list=[];

            if(this.dependencie_notify_select!==null){
                try {
                    this.title_m="Solicitando";
                    this.activeModal(this.id_m_progress);
                    let rpb= await axios.get(`getDocPendingClose/${this.dependencie_notify_select.id}?api_token=${Vue.auth.getToken()}`);
                    // console.log(rpb);
                    let auxRpb=rpb.data;
                    if(auxRpb.length>0){
                        
                        auxRpb.forEach((dts)=>{
                            let daysTranscurrent=this.diffDates(dts.date_approve);
                            let auxDocApprob={
                                id_exec:dts.id_exec,
                                port:dts.port,
                                correlative:dts.correlative,
                                year_egress:dts.year_egress,
                                date_approve:dts.date_approve,
                                type_document:dts.type_document,
                                import_gral_approv:dts.import_gral_approv,
                                glosa:dts.glosa,
                                notify:dts.notify,
                                days_current:daysTranscurrent,
                                disabled:true
                            }
                            this.dependencie_notify_list.push(auxDocApprob);
                        })                        
                    }
                    // console.log(this.dependencie_notify_list);
                    setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);
                    }, 500)
                } catch (error) {
                    setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);
                        toastr.error('Error comunique al Administrador', 'Error');
                    }, 500)
                }
                
            }else{
                toastr.warning('Seleccione una opcion para la busqueda', 'Error');
            }
        },

        async mRegisterApprovNegate(e, tp){
            let mes;
            let title;
            if(tp){
                mes=`¿Esta seguro(a) de <b>APROBAR</b> el Documento ${e.type_document} ${e.correlative}/${e.year_egress} de Ejecucion de Gasto de ${e.port}?`;
                title='Aprobacion Documento';
            }else{
                mes=`¿Esta seguro(a) de <b>NEGAR</b> el Documento ${e.type_document} ${e.correlative}/${e.year_egress} de Ejecucion de Gasto de ${e.port}?`;
                title="Documento Rechazado";
            }
            let dts_aprov={
                id_exec:e.id_exec,
                approve:tp,
                number_prevent:e.prevent
            }         
            // console.log(dts_aprov)
            let message = {
                title: title,
                body: mes
                };

                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

            npr.then( async (msg) =>{
                if(msg){
                    try {
                        this.title_m="Registrando";
                        this.activeModal(this.id_m_progress);
                        
                        let adp=await axios.post(`saveApproveDocument?api_token=${Vue.auth.getToken()}`, qs.stringify(dts_aprov));
                        // console.log(adp);
                        if(adp.data.status){
                            // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                            toastr.success(adp.data.response, 'Exito');
                            this.mDeleteDocumentApprove(e.id_exec);
                            // eliminar al documento de la lista
                            
                        }else{                            
                            // solo mostramos el mensaje de error
                            toastr.error(`${adp.data.response}`, 'Error');
                        }
                        setTimeout(()=>{
                            this.inactiveModal(this.id_m_progress);
                        }, 500)
                    } catch (error) {
                        toastr.error('Consulte al administrador', 'Error');
                        setTimeout(()=>{
                            this.inactiveModal(this.id_m_progress);
                        }, 500)
                    }
                }else{
                    console.log('se ha rechazado el registro de gasto');
                }
            })
        },
        mApprovDocument(e){
            if(e.prevent!==null && e.prevent.length > 0){
                this.mRegisterApprovNegate(e, true);

            }else{
                toastr.warning(`Indique el numero de documento preventivo para el Doc. ${e.correlative}/${e.year_egress}`, 'Advertencia');
            }
        },
        mNegateDocument(e){
            this.mRegisterApprovNegate(e, false);
        },
        mDeleteDocumentApprove(quest){
            let idel;
            let auxBudget;
            this.dependencie_approv_request.forEach((v, key)=>{
                if(quest===v.id_exec){
                    idel=key;
                }
            });
            // posteriormente eliminar la copia en el auxiliar                        
            this.dependencie_approv_request.splice(idel, 1);
        },
        async mSearchPendingApprov(){
            
            this.dependencie_approv_request=[];

            if(this.dependencie_approv_select!==null){
                try {
                    this.title_m="Solicitando";
                    this.activeModal(this.id_m_progress);
                    let rpb= await axios.get(`getDocPendingApprov/${this.dependencie_approv_select.id}?api_token=${Vue.auth.getToken()}`);
                    // console.log(rpb);
                    let auxRpb=rpb.data;
                    if(auxRpb.length>0){
                        
                        auxRpb.forEach((dts)=>{
                            let daysTranscurrent=this.diffDates(dts.date_present);
                            let auxDocApprob={
                                id_exec:dts.id_exec,
                                port:dts.port,
                                correlative:dts.correlative,
                                year_egress:dts.year_egress,
                                date_present:dts.date_present,
                                type_document:dts.type_document,
                                import_gral_approv:dts.import_gral_approv,
                                glosa:dts.glosa,
                                prevent:null,
                                days_current:daysTranscurrent
                            }
                            this.dependencie_approv_request.push(auxDocApprob);
                        })                        
                    }
                    setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);
                    }, 500)
                } catch (error) {
                    setTimeout(()=>{
                        this.inactiveModal(this.id_m_progress);
                        toastr.error('Error comunique al Administrador', 'Error');
                    }, 500)
                }
                
            }else{
                toastr.warning('Seleccione una opcion para la busqueda', 'Error');
            }
        },
        mGetToday(){
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
            this.date_req_exec=date_aux;           
        },
        async mCallDependencies(){
            // let dr=await axios.get(`getAllDependecies`);
            // let tf=await axios.get(`globals/file`);
            let dr=await axios.get(`getAllDependecies?api_token=${Vue.auth.getToken()}`);
            let tf=await axios.get(`globals/file?api_token=${Vue.auth.getToken()}`);
            this.type_files=tf.data;
            this.dependencies=dr.data;
        },
        async mCallBudgetRegisters(){
            // limpiar los registros de las dependencias
            this.budget_ceiling_dependencie=[];
            // let ra=await axios.get(`getListCeiling/${this.dependencie_exec_ceiling.id}/${this.cYearVigent}`);
            // let ra=await axios.get(`getListCeiling/${this.dependencie_exec_ceiling.id}/${this.cYearVigent}?api_token=${Vue.auth.getToken()}`);
            let ra=await axios.get(`getListCeiling/0?api_token=${Vue.auth.getToken()}`);
            this.year_vigent_budget=ra.data[0].year_assignment;
            console.log(this.year_vigent_budget);
            this.budget_ceiling_dependencie=ra.data;
        },
        mAddExec(){
            
            // deshabilitamos el camio de dependencia y los meses que se trabajara
            let v=this.mValidateFormRegister();
            // vaciamos el campo de importe solicitado e importe aprobado
            let vi=0;
            if(v){     
                // validar que el item a ingresar no este registrado
                if(this.dts_budget_exec.length===0){
                    // registramos la cabecera o datos principales
                    this.dts_exec_master.y=this.year_vigent_budget;
                    this.dts_exec_master.year_exec=this.year_execute
                    this.dts_exec_master.dependencie=this.dependencie_exec_ceiling.id;
                    this.dts_exec_master.t_document=this.file_select.id;
                    this.dts_exec_master.f_select=this.font_select.id;
                    this.dts_exec_master.d_document=this.desc_file;
                    this.dts_exec_master.date_present=this.date_req_exec;
                    // console.log(typeof this.month_select);
                    // console.log(this.month_select);
                    // console.log(this.month_select.length);
                    // se aplica si solo se eligira un mes solamente
                    // let am={
                    //         id:this.month_select.id,
                    //         title:this.month_select.title   
                    //     }
                    // this.dts_exec_month.push(am);
                    // ESTE APLICAR SI SE REGISTRA VARIOS MESES
                    if(typeof this.month_select ==='object' ){
                        // si es una funcion
                        this.month_select.forEach((d)=>{
                            let am={
                                id:d.id,
                                title:d.title   
                            }
                            this.dts_exec_month.push(am);
                        });
                    }else{
                        // no es una funcion
                        console.log('no es array')
                    }

                    
                }
                // auxiliar de datos de presupuesto
                let a={
                    code_assign:this.budget_ceiling_select.code_assign,
                    budget_code:this.budget_ceiling_select.budget_code,
                    glosa:this.budget_ceiling_select.glosa,
                    import_req:this.import_req,
                    import_approv:this.import_approv,
                    import_dif:this.cDiffReqApprov
                }
                this.dts_exec_master.import_req_gral=parseFloat(this.dts_exec_master.import_req_gral) + parseFloat(this.import_req);
                this.dts_exec_master.import_approv_gral=parseFloat(this.dts_exec_master.import_approv_gral) + parseFloat(this.import_approv);

                // console.log(this.dts_exec_master.import_req_gral);
                // console.log(this.dts_exec_master.import_approv_gral);

                this.dts_budget_exec.push(a);
                this.import_req=null;
                this.import_approv=null;
                this.is_disabled=true;                
            }
        },
        mValidateFormRegister(){
            let ce=0;
            // console.log(this.dependencie_exec_ceiling.id)
            if(this.dependencie_exec_ceiling.id === 0){
                // console.log(`error no hay datos seleccionados`);
                toastr.warning(`Seleccione una Dependencia`, 'Advertencia');
                ce++;
            }
            
            if(this.month_select.length === 0){
                toastr.warning(`Debe seleccionar al menos un mes`, 'Advertencia');
                ce++;
            }

            if(this.year_execute === 0){
                toastr.warning(`Debe seleccionar la gestion correspondiente`, 'Advertencia');
                ce++;
            }
            
            if(this.font_select.length === 0 ){
                toastr.warning(`Seleccione una fuente de Egreso`, 'Advertencia');
                ce++;
            }

            if(this.budget_ceiling_select.length === 0){
                toastr.warning(`Seleccione una partida`, 'Advertencia');
                ce++;
            }
            
            
            if(this.file_select.length === 0){
                toastr.warning(`Seleccione un tipo de documento`, 'Advertencia');
                ce++;
            }

            if(this.desc_file === null || parseInt(this.desc_file.length) <= 10){
                toastr.warning(`Describa mejor los detalles del documento`, 'Advertencia');
                ce++;
            }
            
            if( (this.import_req === 0 && this.import_approv === 0) || (this.import_req === null && this.import_approv === null) ){
                toastr.warning(`Indique el Importe Solicitado y Aprobado `, 'Advertencia');
                ce++;
            }
            
            if( (this.import_req < 0 || this.import_approv < 0) ||  (this.import_req < 0 && this.import_approv < 0) ){
                toastr.warning(`Los importes deben ser de valor positivo `, 'Advertencia');
                ce++;
            }

            if(this.dts_budget_exec.length > 0){
                let cel=0;
                    this.dts_budget_exec.forEach((d)=>{                        
                        if(d.code_assign === this.budget_ceiling_select.code_assign && d.budget_code===this.budget_ceiling_select.budget_code){
                            toastr.warning(`El codigo ${d.budget_code} ya se existe en la solicitud`, 'Advertencia');
                            ce++;
                        }
                    })
            }

            if(ce>0){
                return false;
            }else{
                return true;
            }
        },
        mResetForm(){
            this.is_disabled=false;
            // eliminar todos los datos de envio y limpiar los campos de texto e importes
            this.dts_exec_master.y=0;
            this.dts_exec_master.year_exec=0;
            this.dts_exec_master.dependencie=null;
            this.dts_exec_master.t_document=null;
            this.dts_exec_master.date_present=null;
            this.dts_exec_master.import_req_gral=0;
            this.dts_exec_master.import_approv_gral=0;

            this.dts_exec_month=[];
            this.dts_budget_exec=[];
            this.desc_file=null;
        },
        mDeleteItem(c){
            let idel;
            let auxBudget;
            this.dts_budget_exec.forEach((v, key)=>{
                if(c===v.budget_code){
                    auxBudget={
                        code:v.budget_code,
                        glosa:v.glosa,
                        import_req:v.import_req,
                        import_approv:v.import_approv
                    }

                    idel=key;
                }
            });
            this.dts_exec_master.import_req_gral=parseFloat(this.dts_exec_master.import_req_gral) - parseFloat(auxBudget.import_req);
            this.dts_exec_master.import_approv_gral=parseFloat(this.dts_exec_master.import_approv_gral) - parseFloat(auxBudget.import_approv);
            // posteriormente eliminar la copia en el auxiliar                        
            this.dts_budget_exec.splice(idel, 1);
            toastr.error(`El codigo ${auxBudget.code} ${auxBudget.glosa} ha sido eliminado`, 'Advertencia');
        },
        mSaveExecute(){
            // validar que los campos de descripcion esten llenos y que los registros maestro y datos de presupuestos esten registrados

            // validar si el importe es menor a lo presupuestado cuando llegue
            // console.log(this.month_select);
            let message = {
                title: 'Registrar Gasto',
                body: `¿Desea continuar con el registro del gasto correspondiente al mes de <b>${this.month_select.title}</b> del año <b>${this.year_execute}</b> para <b>${this.dependencie_exec_ceiling.name_port}</b> y debitando del <b>presupuesto de la gestion ${this.year_vigent_budget}</b>?`
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            });

            npr.then( async (msg) =>{
                if(msg){
                    try {
                        this.title_m="Registrando";
                        this.activeModal(this.id_m_progress);
                        let dts_exec={
                            head:JSON.stringify(this.dts_exec_master),
                            detail:JSON.stringify(this.dts_budget_exec),
                            months:JSON.stringify(this.dts_exec_month)                            
                        }

                        // esperar a la respuesta si es rechazada indicar el error para ver si el presupuesto fue superado
                        
                        // let reb=await axios.post(`saveExecute`, qs.stringify(dts_exec));
                        let reb=await axios.post(`saveExecute?api_token=${Vue.auth.getToken()}`, qs.stringify(dts_exec));
                        
                        if(reb.data[0].status){
                            // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                            toastr.success(reb.data[0].response, 'Exito');
                            this.mResetForm();                            
                        }else{
                            // indicamos el error y no limpiamos
                            // verificar si es un array
                            let cAux = reb.data[0].response;
                            if(cAux.length>0){
                                // mostramos los errores de la ejecucion presupuestaria indicando que sobrepasan
                                cAux.forEach((code)=>{
                                    toastr.error(`La partida ${code.code_assign} ${code.glosa} asignada a la gestion es menor a lo solicitado`, 'Error');
                                })
                            }else{
                                // solo mostramos el mensaje de error
                                toastr.error(`${reb.data[0].response}`, 'Error');
                            }
                        }
                        setTimeout(()=>{
                            this.inactiveModal(this.id_m_progress);
                        }, 500)
                    } catch (error) {
                        toastr.error('Consulte al administrador', 'Error');
                        setTimeout(()=>{
                            this.inactiveModal(this.id_m_progress);
                        }, 500)
                    }
                }else{
                    console.log('se ha rechazado el registro de gasto');
                }
            })
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        },
        diffDates (f1)
        {
            let f=new Date();
            let fa=f.getFullYear() + "-" + (f.getMonth() +1) + "-" + f.getDate();            
            var aFecha1 = f1.split('-');
            var aFecha2= fa.split('-');
            var fFecha1 = Date.UTC(aFecha1[0],aFecha1[1]-1,aFecha1[2]);
            var fFecha2 = Date.UTC(aFecha2[0],aFecha2[1]-1,aFecha2[2]);
            //  var dif = fFecha2 - fFecha1;
            var dif = fFecha2 - fFecha1;
            var dias = Math.floor(dif / (1000 * 60 * 60 * 24));
            return dias;
        }
    },
    computed:{
        cDiffReqApprov(){
            let d=this.import_req-this.import_approv;
            return d;
        }
    },
    components:{
        'modal-loading':modalLoading,
        'modal-view':modalView
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
textarea{
    resize: none;
}
.my-scroll {
    width: 600px;
    height: 100px;
    padding: 5px;
    border-radius: 10px;
    /* background-color: rgb(229, 230, 247);     */
    /* font-size: 0.8em; */
    text-align: justify;
    /* border: 1px solid; */
    overflow: scroll;
    word-wrap: break-word;
}

</style>


// WEBPACK FOOTER //
// src/components/finanzas/BudgetExecute.vue